// extracted by mini-css-extract-plugin
export default {"arrow-icon":"ArrowIcon_arrow-icon__KwNS5"};